import { CLASS_UOM_CONVERSION, generateUOMConversionURL } from "c8-platform";
import DeleteController from "csi/action/DeleteController";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

const DeleteUOMConversion = declare(DeleteController, {

	/** @property {C8Node} _uomConversion - Node of the current conversion */
	_uomConversion: null,

	/** @property {C8Node} _uomInverseConversion - Node of the inverse conversion */
	_uomInverseConversion: null,

	/** @property {C8Node} internalUOMNode - InternalUOM of the current conversion */
	internalUOMNode: null,

	/** @property {C8Node} externalUOMNode - ExternalUOM of the current conversion */
	externalUOMNode: null,

	/**
     * @override
     * Add confirmation message to delete two UOMConversions
     */
	confirmAction(params): void {
		this._findConversionNodes();
		const uomConversionsLoc = locale.typePlural(CLASS_UOM_CONVERSION);
		params.title = `Delete ${uomConversionsLoc}?`;
		params.message = `${uomConversionsLoc} - ${this.internalUOMNode.$Name} to ${this.externalUOMNode.$Name} \
		and ${this.externalUOMNode.$Name} to ${this.internalUOMNode.$Name} will be permanently deleted.`;
		this.inherited(arguments);
	},

	/**
	 * Get inverse conversion node and member variables
	 */
	_findConversionNodes(): void {
		const node = this.getNode();
		this._uomConversion = node;
		this.internalUOMNode = this.m_cache.getNode(node.InternalUOM, true);
		this.externalUOMNode = this.m_cache.getNode(node.ExternalUOM, true);

		const uomTypeName = this.m_cache.getNode(this.internalUOMNode.__Parent__, true).$Name;
		const uomIntName = this.internalUOMNode.$Name;
		const uomExtName = this.externalUOMNode.$Name;
		const inverseConversionCNL = generateUOMConversionURL(uomTypeName, uomExtName, uomIntName);
		this._uomInverseConversion = this.getCache().getNode(inverseConversionCNL, true);
	},

	/** 
	 * @override
	 * Delete inverse UOMConversion in addition to the current UOMConversion
	 */
	toWriter(): void {
		this.inherited(arguments);
		this.m_writer.deleteNode(this._uomInverseConversion.$URL);
	},

	/** 
	 * @override
	 * Clear cache and refresh data after deleting conversion pair
	 */
	postProcessSuccess(): void {
		this.inherited(arguments);
		this.getCache().remove(this._uomConversion.$URL);
		this.getCache().remove(this._uomInverseConversion.$URL);
		this.widget.refreshData();
	},

});

export = DeleteUOMConversion;